import { render, staticRenderFns } from "./BookmarksReplace.vue?vue&type=template&id=c71173d6&scoped=true"
import script from "./BookmarksReplace.vue?vue&type=script&lang=ts"
export * from "./BookmarksReplace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71173d6",
  null
  
)

export default component.exports